import { AuthenticationResult, PublicClientApplication } from "@azure/msal-browser";
import { buildTenantAuthority } from "./auth.helper";

export async function resolveAuthSession(defaultInstance: PublicClientApplication) {
  const stored = localStorage.getItem("authTenant");
  const isSignup = sessionStorage.getItem("signupInProgress") === "true";
  let instance = defaultInstance;
  if (stored) {
    const tenant = JSON.parse(stored);
    instance = new PublicClientApplication({
      auth: {
        clientId: tenant.clientId,
        authority: buildTenantAuthority(tenant),
        knownAuthorities: [new URL(tenant.instance).hostname],
        redirectUri: process.env.REACT_APP_REDIRECT_URL || "/",
        navigateToLoginRequestUrl: false,
      },
      cache: { cacheLocation: "localStorage" },
    });
  }
  await instance.initialize();
  let response: AuthenticationResult | null = await instance.handleRedirectPromise();
  if (!response) {
    const account = instance.getActiveAccount() || instance.getAllAccounts()[0];
    if (account) response = await instance.acquireTokenSilent({ scopes: [], account });
  }
  if (response?.account) instance.setActiveAccount(response.account);
  return { instance, response, isSignup };
}
